import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { giveFocusToInput } from 'utilities';
import { ListHeaderProps } from './ListHeader.props';
import { SearchTextField } from './ListHeader.styles';

const ListHeader = ({ onInputChange, searchState, firmList, inputFilterRef, listLimit = 0 }: ListHeaderProps) => {
  const getFirmBoxCaption = () => {
    if (!isEmpty(firmList)) {
      return 'Select a Firm';
    }
    if (!firmList) {
      return 'Loading Firms';
    }
    return 'There is nothing here yet';
  };

  useEffect(() => {
    giveFocusToInput(inputFilterRef as React.RefObject<HTMLInputElement>);
  }, [inputFilterRef]);

  if ((firmList?.length ?? 0) > listLimit) {
    return (
      <SearchTextField
        inputRef={inputFilterRef}
        label="SELECT A FIRM"
        variant="standard"
        value={searchState}
        onChange={onInputChange}
      />
    );
  }
  return <Typography variant="h2">{getFirmBoxCaption()}</Typography>;
};

export default ListHeader;
